// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1poY7","detailsBorder":"styles_detailsBorder__3_Sp3"};